import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import Swal from 'sweetalert2';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { ClientService } from '../../../../services/clients';
import { PriceListService } from '../../../../services/pricelist';

@Component({
  selector: 'app-createprice',
  templateUrl: './createprice.component.html',
  styleUrl: './createprice.component.scss'
})
export class CreatepriceComponent {




  data!: FormGroup;
  dataForm: FormData = new FormData();
  contentReady: boolean = false;
  isMobile: boolean = false;
  isAr: boolean = false;
  editId!: any;
  isUpdatePage: boolean = false;
  systemAccess: boolean = false;
  type: string = 'text';

  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  @ViewChild('mySelect') mySelect!: MatSelect;

  constructor(
    private fb: FormBuilder,
    private _pricelist: PriceListService,
    private router: Router,
    private route: ActivatedRoute,
    private deviceService: DeviceDetectorService
  ) { }

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobileDevice();
    this.isAr = localStorage.getItem("language") === "ar";
    this.contentReady = true;
        this.initForm();
 this.route.queryParams.subscribe(params => {
  if (params["id"]) {
    this.isUpdatePage = true;
    this.editId = +params["id"]; // نحول إلى رقم
    // ✨ املا النموذج من params
    this.data.patchValue({
      university_name: params["university_name"] || '',
      fees: params["fees"] || 0
    });
  }
});



  }

initForm() {
  this.data = this.fb.group({
    university_name: ['', Validators.required],
    fees: [0, [Validators.required, Validators.min(0)]]
  });
}

  appendPostDtata() {
    this.dataForm = new FormData();

    Object.entries(this.data.value).forEach(([key, value]) => {
      // لو القيمة Boolean، نحولها لقيمة مناسبة
      if (typeof value === 'boolean') {
        this.dataForm.append(key, value ? '1' : '0'); // Laravel بيفضل 1 و 0 في boolean
      } else if (value !== null && value !== undefined) {
        this.dataForm.append(key, value.toString());
      }
    });

  }



  onSubmit() {
    this.appendPostDtata();

    if (this.isUpdatePage) {
      this.onEdit();
    } else {
      this.onAdd();
    }
  }

  onAdd() {
    this.contentReady = true;
    this._pricelist.create(this.dataForm).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? "تم إنشاء الجامعة" : 'created',
          showConfirmButton: false,
          timer: 1500,
        });

        this.contentReady = false;
            const redirectUrl = '/pricelist';
        this.router.navigateByUrl(redirectUrl);
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          title: this.isAr ? "فشل إنشاء الجامعة" : 'not created',
          confirmButtonText: this.isAr ? 'تمام' : 'OK',
        });

        this.contentReady = false;
      }
    });
  }

 onEdit() {
   this.contentReady = true;
   this._pricelist.update(this.editId,this.dataForm).subscribe({
     next: (res) => {
       Swal.fire({
         icon: 'success',
         title: this.isAr ? "تم تعديل الجامعة" : 'Client updated',
         showConfirmButton: false,
         timer: 1500,
       });

       this.contentReady = false;
       const redirectUrl = '/pricelist';
       this.router.navigateByUrl(redirectUrl);
     },
     error: (err) => {
       Swal.fire({
         icon: 'error',
         title: this.isAr ? "فشل تعديل الجامعة" : 'Client not updated',
         confirmButtonText: this.isAr ? 'تمام' : 'OK',
       });

       this.contentReady = false;
     }
   });
 }





}
